import React from 'react';
import { Palette } from '../common/IconButton';

export interface LegendItem {
    icon: React.ReactNode;
    color: Palette;
    label: string;
    description: string;
}

interface ButtonLegendContentProps {
    items: LegendItem[];
}

const colorClasses: Record<Palette, string> = {
    blue: 'border-blue-500 text-blue-500',
    green: 'border-green-500 text-green-500',
    orange: 'border-orange-500 text-orange-500',
    red: 'border-red-500 text-red-500',
};

const ButtonLegendContent: React.FC<ButtonLegendContentProps> = ({ items }) => {
    if (items.length === 0) {
        return <p className="text-sm text-gray-500 dark:text-gray-400">No actions available.</p>;
    }

    return (
        <div className="space-y-4">
            {items.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                    <div className={`inline-flex items-center justify-center w-10 h-10 shrink-0 rounded-lg border ${colorClasses[item.color]}`}>
                        {item.icon}
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{item.label}</p>
                        <p className="text-sm text-gray-500 dark:text-gray-400">{item.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ButtonLegendContent;
